module.exports = __webpack_public_path__ + "static/media/cws5_banner_loyalty.0d95709e.jpg";